module.exports = __webpack_public_path__ + "static/media/kusunda_hero-min.7e00467a.png";